let elementQueries = require('css-element-queries')

angular.module('eatself').directive('oneLine', function($timeout) {
	return {
		scope: {},
		link: function($scope, $element, $attrs) {
			$element.css('display','inline-block');
			$element.css('white-space','nowrap');
			$element.parent().css('display','block');
			new elementQueries.ResizeSensor($element,() => {
				if (!$scope.checking) {
					checkWidth();
				}
			})
			$timeout(checkWidth);
			$(window).on('resize',checkWidth);

			function checkWidth() {
				let w = $element.innerWidth();
				// let padding = parseInt($element.css('padding-left')) + parseInt($element.css('padding-right'));
				let wp = $element.parent().innerWidth();
				if (w > wp) {
					let fs = $element.css('font-size');
					$element.css('font-size',parseInt(fs) - 1);
					$scope.checking = true;
					$timeout(checkWidth);
				}
				$scope.checking = false;
			}
		}
	};
})
